import { useMutation } from 'react-query';
import { createOffsiteCampaignMutation, CreateOffsiteCampaignRequest } from './createOffsiteCampaignMutation';

export const useCreateOffsiteCampaignMutation = () => {
  return useMutation((payload: CreateOffsiteCampaignRequest) => createOffsiteCampaignMutation(payload));
};
